import { z } from "zod"
import { METER_POINT_ID_LENGTH } from "../constants/meterPointLength"
import { isMeterPointIdValid } from "../utils/isMeterPointIdValid"

export const electricityMeterPointIdSchema = z
    .string({ error: "Numéro de PDL requis" })
    .transform((s) => s.replaceAll(/\s/g, ""))
    .pipe(
        z
            .string()
            .length(METER_POINT_ID_LENGTH, {
                message: `Le numéro du PDL doit avoir ${METER_POINT_ID_LENGTH} chiffres.`,
            })
            .refine(isMeterPointIdValid, {
                message: "Identifiant de PDL invalide",
            })
    )

export const gasMeterPointIdSchema = z
    .string({ error: "Numéro de PCE requis" })
    .transform((s) => s.replaceAll(/\s/g, ""))
    .pipe(
        z
            .string()
            .length(METER_POINT_ID_LENGTH, {
                message: `Le numéro du PCE doit avoir ${METER_POINT_ID_LENGTH} chiffres.`,
            })
            .refine(isMeterPointIdValid, {
                message: "Identifiant de PCE invalide",
            })
    )
